import { createApp, watch } from 'vue'
import App from './App.vue'
import { createAppRouter, titleFor } from './router.js'
import { bindWindowToRouter, loadAvailable } from './composables/useWindow.js'
import { bindScopeToRouter } from './lib/scope.js'
import { initTheme } from './composables/useTheme.js'
import { lang } from './lib/i18n.js'
import './styles/tokens.css'
import './styles/base.css'

// The theme is applied before the first mount so no chart is ever built against
// the wrong set of tokens. `index.html` has already set `data-theme` to stop
// the flash; this fills in the custom properties behind it.
initTheme()

// The document's language follows the one on screen (lib/i18n.js).
document.documentElement.lang = lang.value

const router = createAppRouter()
// The window reads and writes the URL, so it needs the router before anything
// renders. docs/ARCHITECTURE.md: every state this dashboard can be in is a link.
bindWindowToRouter(router)
bindScopeToRouter(router)

// Which windows hold rows. Started here rather than in a component so the
// picker, the page header and any modal deep-linked into on a cold load are all
// waiting on one request instead of three.
loadAvailable().catch(() => {
  /* surfaced by the controls, never swallowed silently */
})

// Mounted only once the router has resolved the first route.
//
// The pages are lazy chunks, so before resolution `route.name` is undefined —
// and App.vue decides whether to draw the navigation bar from exactly that.
// Mounting early flashed the bar across the top of the Overview, which is the
// one page that is meant to have none, for as long as its chunk took to arrive.
const app = createApp(App).use(router)
// The tab's title follows a switch of language, not only a change of page.
watch(lang, () => {
  document.title = titleFor(router.currentRoute.value)
})
router.isReady().then(() => app.mount('#app'))
